export const MESSAGES = {
    CHAT_VISUALIZATION_HIDDEN: 'To view the full visualization, please switch to the full chat window by clicking the link below.',
    ASK_GUARDIAN_PRE_TEXT: `Welcome! I'm **iHub**, your AI-powered assistant, here to assist with any questions or tasks. 
    \nHow may I help you today?`,
    NO_KPI_INSIGHTS: 'No KPI insights found. Please expand filters and check.',
    DATA_LOADING_PLACEHOLDER: 'Data is loading...'
}